module.exports = __webpack_public_path__ + "system/img/view.7ba464ab.png";